module.exports = __webpack_public_path__ + "static/media/green-wave.51d80c49.svg";